import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function ContactPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="ช่องทางการติดต่อ"
            apiPath="/contact-infos" 
            fieldKey="name"
            createDefaultName="รายการใหม่" 
            initialItems={[]}
        />
    );
}
